import { render } from "./finalResults.vue?vue&type=template&id=56ceed8b&scoped=true"
import script from "./finalResults.vue?vue&type=script&lang=js"
export * from "./finalResults.vue?vue&type=script&lang=js"

import "./finalResults.vue?vue&type=style&index=0&id=56ceed8b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56ceed8b"]])

export default __exports__